(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="kombin-tamamla"]';
  var initializedRoots = new WeakSet();

  function qs(root, selector) {
    return root.querySelector(selector);
  }

  function qsa(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function initKombinSection(root) {
    if (initializedRoots.has(root)) return;
    initializedRoots.add(root);

    setupCarousel(root);
    setupDrawers(root);
  }

  function setupCarousel(root) {
    var cards = qsa(root, '[data-kombin-card]');
    var prevBtn = qs(root, '[data-kombin-prev]');
    var nextBtn = qs(root, '[data-kombin-next]');
    var counter = qs(root, '[data-kombin-counter]');
    if (cards.length <= 1) return;

    var activeIndex = 0;

    function render() {
      cards.forEach(function (card, i) {
        if (i === activeIndex) {
          card.setAttribute('data-kombin-active', '');
        } else {
          card.removeAttribute('data-kombin-active');
        }
      });
      if (counter) {
        counter.textContent = (activeIndex + 1) + ' / ' + cards.length;
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        activeIndex = (activeIndex - 1 + cards.length) % cards.length;
        render();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        activeIndex = (activeIndex + 1) % cards.length;
        render();
      });
    }

    render();
  }

  function setupDrawers(root) {
    var reviewTriggers = qsa(root, '[data-kombin-review-trigger]');

    reviewTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('data-kombin-review-trigger');
        openDrawer(root, id);
      });
    });

    qsa(root, '[data-kombin-drawer]').forEach(function (drawer) {
      qsa(drawer, '[data-kombin-drawer-close]').forEach(function (closeEl) {
        closeEl.addEventListener('click', function () {
          closeDrawer(drawer);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.hasAttribute('data-kombin-drawer-open')) {
          closeDrawer(drawer);
        }
      });
    });

    setupAlternates(root);
    setupSelection(root);
    setupCartActions(root);
  }

  function setupAlternates(root) {
    qsa(root, '[data-kombin-item]').forEach(function (item) {
      var toggle = qs(item, '[data-kombin-alternates-toggle]');
      var list = qs(item, '[data-kombin-alternates-list]');

      if (toggle && list) {
        toggle.addEventListener('click', function () {
          var willShow = list.hasAttribute('hidden');
          if (willShow) {
            list.removeAttribute('hidden');
          } else {
            list.setAttribute('hidden', '');
          }
          toggle.setAttribute('aria-expanded', willShow ? 'true' : 'false');
        });
      }

      var thumbs = qsa(item, '[data-kombin-alternate]');
      if (thumbs.length === 0) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) {
            t.removeAttribute('aria-current');
          });
          thumb.setAttribute('aria-current', 'true');
          applyAlternateToItem(item, thumb, root);
        });
      });
    });
  }

  function getI18n(root) {
    return {
      addedConfirmation: root.getAttribute('data-i18n-added-confirmation') || 'Sepete eklendi',
      goToCart: root.getAttribute('data-i18n-go-to-cart') || 'Sepete Git',
      selectSizeWarning: root.getAttribute('data-i18n-select-size-warning') || '',
      soldOut: root.getAttribute('data-i18n-sold-out') || 'Tükendi',
      totalZero: root.getAttribute('data-i18n-total-zero') || 'TOPLAM 0 ÜRÜN',
      totalOne: root.getAttribute('data-i18n-total-one') || 'TOPLAM 1 ÜRÜN',
      totalOther: root.getAttribute('data-i18n-total-other') || 'TOPLAM 2 ÜRÜN'
    };
  }

  function formatTotalLabel(root, count) {
    var i18n = getI18n(root);
    if (count === 0) return i18n.totalZero;
    if (count === 1) return i18n.totalOne;
    return i18n.totalOther.replace(/\d+/, String(count));
  }

  function applyAlternateToItem(item, thumb, root) {
    var titleLink = qs(item, '[data-kombin-item-title] a');
    var priceEl = qs(item, '[data-kombin-item-price]');
    var imageWrap = qs(item, '[data-kombin-item-image]');
    var sizeSelect = qs(item, '[data-kombin-item-size]');
    var checkbox = qs(item, '[data-kombin-item-checkbox]');

    if (titleLink) {
      titleLink.textContent = thumb.getAttribute('data-product-title');
      titleLink.setAttribute('href', thumb.getAttribute('data-product-url'));
    }

    if (priceEl) {
      var compareAt = thumb.getAttribute('data-product-compare-at-price');
      var price = thumb.getAttribute('data-product-price');
      if (compareAt) {
        priceEl.innerHTML = '<s class="t-subdued">' + compareAt + '</s> <span class="sale">' + price + '</span>';
      } else {
        priceEl.innerHTML = '<span>' + price + '</span>';
      }
    }

    if (imageWrap) {
      var img = imageWrap.querySelector('img');
      if (img) {
        img.setAttribute('src', thumb.getAttribute('data-product-image'));
        img.setAttribute('srcset', '');
      }
    }

    if (sizeSelect) {
      var variantsJson = qs(thumb, '[data-kombin-alternate-variants]');
      var variants = {};
      try {
        variants = JSON.parse(variantsJson ? variantsJson.textContent : '{}');
      } catch (e) {
        variants = {};
      }

      var rowVariantsScript = qs(item, '[data-kombin-item-variants]');
      if (rowVariantsScript && variantsJson) {
        rowVariantsScript.textContent = variantsJson.textContent;
      }

      var hasVariants = thumb.getAttribute('data-product-has-variants') === 'true';
      var i18n = getI18n(root);

      if (sizeSelect.tagName === 'SELECT') {
        sizeSelect.innerHTML = '';
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = sizeSelect.getAttribute('data-placeholder-text') || 'Bedeninizi Seçiniz';
        sizeSelect.appendChild(placeholder);

        Object.keys(variants).forEach(function (variantId) {
          var v = variants[variantId];
          var option = document.createElement('option');
          option.value = variantId;
          option.textContent = v.title + (v.available ? '' : ' — ' + i18n.soldOut);
          if (!v.available) option.disabled = true;
          sizeSelect.appendChild(option);
        });
      } else if (hasVariants) {
        sizeSelect.value = '';
      } else {
        var singleVariantIds = Object.keys(variants);
        sizeSelect.value = singleVariantIds.length ? singleVariantIds[0] : '';
      }
    }

    if (checkbox) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getVariantsData(item) {
    var script = qs(item, '[data-kombin-item-variants]');
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return {};
    }
  }

  function isItemSelectable(item) {
    var checkbox = qs(item, '[data-kombin-item-checkbox]');
    var sizeInput = qs(item, '[data-kombin-item-size]');
    if (!checkbox || checkbox.disabled || !checkbox.checked) return false;
    if (!sizeInput || !sizeInput.value) return false;
    return true;
  }

  function getItemVariantPrice(item) {
    var sizeInput = qs(item, '[data-kombin-item-size]');
    if (!sizeInput || !sizeInput.value) return 0;
    var variants = getVariantsData(item);
    var variant = variants[sizeInput.value];
    if (!variant || typeof variant.price !== 'number') return 0;
    return variant.price;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY' });
  }

  function recalculateDrawerTotal(drawer, root) {
    var items = qsa(drawer, '[data-kombin-item]');
    var count = 0;
    var totalCents = 0;

    items.forEach(function (item) {
      item.removeAttribute('data-kombin-item-warning');
      if (isItemSelectable(item)) {
        count += 1;
        totalCents += getItemVariantPrice(item);
      }
    });

    var totalEl = qs(drawer, '[data-kombin-total]');
    var addButton = qs(drawer, '[data-kombin-add-selected]');

    if (totalEl) {
      totalEl.setAttribute('data-count', String(count));
      totalEl.textContent = formatTotalLabel(root, count) + ' — ' + formatMoney(totalCents);
    }

    if (addButton) {
      addButton.disabled = count === 0;
    }

    return { count: count, totalCents: totalCents };
  }

  function setupSelection(root) {
    qsa(root, '[data-kombin-drawer]').forEach(function (drawer) {
      var checkboxes = qsa(drawer, '[data-kombin-item-checkbox]');
      var sizeInputs = qsa(drawer, '[data-kombin-item-size]');
      var addSingleButtons = qsa(drawer, '[data-kombin-item-add-single]');

      checkboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
          recalculateDrawerTotal(drawer, root);
        });
      });

      sizeInputs.forEach(function (sizeInput) {
        sizeInput.addEventListener('change', function () {
          var item = sizeInput.closest('[data-kombin-item]');
          var addSingle = item ? qs(item, '[data-kombin-item-add-single]') : null;
          if (addSingle) {
            addSingle.disabled = !sizeInput.value;
          }
          recalculateDrawerTotal(drawer, root);
        });
      });

      addSingleButtons.forEach(function (button) {
        var item = button.closest('[data-kombin-item]');
        var sizeInput = item ? qs(item, '[data-kombin-item-size]') : null;
        var checkbox = item ? qs(item, '[data-kombin-item-checkbox]') : null;
        var soldOut = !!(checkbox && checkbox.disabled);
        button.disabled = soldOut || !(sizeInput && sizeInput.value);
      });

      recalculateDrawerTotal(drawer, root);
    });
  }

  function getCartUrls(root) {
    return {
      add: root.getAttribute('data-cart-add-url') || '/cart/add.js',
      cart: root.getAttribute('data-cart-url') || '/cart.js'
    };
  }

  function addItemsToCart(root, items) {
    var urls = getCartUrls(root);
    return fetch(urls.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var error = new Error(data.description || 'Sepete eklenemedi');
            error.data = data;
            throw error;
          }
          return data;
        });
      })
      .then(function (result) {
        return refreshCartCount(root).then(function () {
          return result;
        });
      });
  }

  function refreshCartCount(root) {
    var urls = getCartUrls(root);
    return fetch(urls.cart, { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        qsa(document, '[data-js-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }

  function setupCartActions(root) {
    qsa(root, '[data-kombin-drawer]').forEach(function (drawer) {
      var addSingleButtons = qsa(drawer, '[data-kombin-item-add-single]');
      var addSelectedButton = qs(drawer, '[data-kombin-add-selected]');

      addSingleButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var item = button.closest('[data-kombin-item]');
          var sizeInput = item ? qs(item, '[data-kombin-item-size]') : null;
          if (!sizeInput || !sizeInput.value) return;

          button.disabled = true;
          addItemsToCart(root, [{ id: sizeInput.value, quantity: 1 }])
            .then(function () {
              showItemConfirmation(item, root);
            })
            .catch(function (err) {
              showItemError(item, err.message);
            })
            .then(function () {
              button.disabled = false;
            });
        });
      });

      if (addSelectedButton) {
        addSelectedButton.addEventListener('click', function () {
          var items = qsa(drawer, '[data-kombin-item]');
          var hasWarning = false;
          var payload = [];

          items.forEach(function (item) {
            item.removeAttribute('data-kombin-item-warning');

            var checkbox = qs(item, '[data-kombin-item-checkbox]');
            if (!checkbox || !checkbox.checked) return;

            if (!isItemSelectable(item)) {
              item.setAttribute('data-kombin-item-warning', '');
              hasWarning = true;
              return;
            }

            var sizeInput = qs(item, '[data-kombin-item-size]');
            payload.push({ id: sizeInput.value, quantity: 1 });
          });

          if (hasWarning || payload.length === 0) {
            return;
          }

          addSelectedButton.disabled = true;
          addItemsToCart(root, payload)
            .then(function () {
              showDrawerConfirmation(drawer, root);
            })
            .catch(function (err) {
              window.alert(err.message || 'Sepete eklenirken bir hata oluştu.');
            })
            .then(function () {
              addSelectedButton.disabled = false;
            });
        });
      }
    });
  }

  function showItemConfirmation(item, root) {
    var existing = qs(item, '[data-kombin-item-confirmation]');
    if (existing) existing.remove();

    var i18n = getI18n(root);
    var el = document.createElement('p');
    el.setAttribute('data-kombin-item-confirmation', '');
    el.className = 'fs-body-60 t-subdued';
    el.textContent = i18n.addedConfirmation;
    var actions = qs(item, '.kombin-tamamla__item-actions');
    if (actions) actions.appendChild(el);

    setTimeout(function () {
      el.remove();
    }, 3000);
  }

  function showItemError(item, message) {
    window.alert(message || 'Sepete eklenirken bir hata oluştu.');
  }

  function showDrawerConfirmation(drawer, root) {
    var footer = qs(drawer, '.kombin-tamamla__drawer-footer');
    if (!footer) return;

    var existing = qs(footer, '[data-kombin-confirmation]');
    if (existing) existing.remove();

    var i18n = getI18n(root);
    var urls = getCartUrls(root);
    var cartPageUrl = urls.cart.replace(/\.js(\?.*)?$/, '');

    var el = document.createElement('p');
    el.setAttribute('data-kombin-confirmation', '');
    el.className = 'fs-body-75';
    el.appendChild(document.createTextNode(i18n.addedConfirmation + ' — '));

    var link = document.createElement('a');
    link.setAttribute('href', cartPageUrl);
    link.textContent = i18n.goToCart;
    el.appendChild(link);

    footer.appendChild(el);
  }

  function openDrawer(root, id) {
    var targetDrawer = null;

    qsa(root, '[data-kombin-drawer]').forEach(function (drawer) {
      if (drawer.getAttribute('data-kombin-drawer') === id) {
        targetDrawer = drawer;
      } else {
        closeDrawer(drawer, { skipBodyUnlock: true });
      }
    });

    if (targetDrawer) {
      targetDrawer.setAttribute('data-kombin-drawer-open', '');
      targetDrawer.setAttribute('aria-hidden', 'false');
      targetDrawer.setAttribute('aria-modal', 'true');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer(drawer, options) {
    options = options || {};
    drawer.removeAttribute('data-kombin-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.removeAttribute('aria-modal');
    if (!options.skipBodyUnlock) {
      document.body.style.overflow = '';
    }
  }

  function initAll() {
    qsa(document, SECTION_SELECTOR).forEach(initKombinSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root = evt.target.querySelector(SECTION_SELECTOR);
    if (root) initKombinSection(root);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var root = evt.target.querySelector(SECTION_SELECTOR);
    if (root) initializedRoots.delete(root);
  });

  window.KombinTamamla = window.KombinTamamla || {};
  window.KombinTamamla._initKombinSection = initKombinSection;
})();